module.exports = __webpack_public_path__ + "img/3.54755c3b.jpg";